import { memo } from 'react';
import { IconProps } from './iconType';

export const ArrowTopBgIcon = memo(({ size, color }: IconProps) => {
  return (
    // export된 svg가 있다면 => 코드창에 열어서 있는 코드 아래 형식처럼 수정하기
    // 디자인 파일에서 svg가 있다면 => svg 코드 복사해서 아래 형식처럼 수정하기
    // xmlns 속성은 제거
    <svg width={size} height={size} viewBox="0 0 25 24" fill="none">
      <circle cx="12.5" cy="12" r="11.5" stroke={color} />
      <path
        d="M12.4998 10.9266L17.0372 15.4639L18.3335 14.1675L12.4998 8.33383L6.66626 14.1675L7.96262 15.4639L12.4998 10.9266Z"
        fill={color}
      />
    </svg>
  );
});

ArrowTopBgIcon.displayName = 'ArrowTopBgIcon';
